import * as React from 'react'

import { GetCustomTableNameDocument } from 'generated/resources/graphql'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { CustomTableHeader } from 'modules/custom_resources/pages/Customizations/CustomTable/CustomTableHeader'

const RootPage = React.lazy(() => import('modules/custom_resources/pages/settings/RootPage'))
const DestroyPage = React.lazy(() => import('modules/custom_resources/pages/settings/DestroyPage'))
const IndexPage = React.lazy(() => import('modules/custom_resources/pages/settings/IndexPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      element: <RootPage />,
      handle: {
        resource: true,
        meta: ({ params, watchQuery }) =>
          watchQuery({
            query: GetCustomTableNameDocument,
            variables: {
              id: String(params['id']),
            },
          }).map(({ data }) => {
            const customTableData = data?.customResources.schema
            return {
              title: customTableData?.name ?? '',
              headerComponent: customTableData ? (
                <CustomTableHeader title={customTableData.name} tableId={customTableData.id} />
              ) : null,
            }
          }),
      },
      children: [
        {
          path: navigation.settings.customizations.customTablesId.path,
          element: <IndexPage />,
          children: [
            {
              path: navigation.settings.customizations.customTablesId.destroy.path,
              element: <DestroyPage />,
            },
          ],
        },
      ],
    },
  ]
}

export default settingsRoutes
